import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/main/index'
    },
    {
      path: '/main',
      name: 'Main',
      component: () => import('./views/main/index.vue'),
      children: [
        {
          path: 'index',
          name: 'Index',
          component: () => import('./views/index/index.vue'),
          meta: { keepAlive: true }
        },
        {
          path: 'merchant',
          name: 'Merchant',
          component: () => import('./views/merchant/index.vue'),
          meta: { keepAlive: true }
        },
        {
          path: 'mine',
          name: 'Mine',
          component: () => import('./views/mine/index.vue'),
          meta: { keepAlive: true }
        }
      ]
    },
    {
      path: '/detail',
      name: 'Detail',
      component: () => import('./views/detail/index.vue'),
      meta: { keepAlive: false }
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('./views/login/index.vue')
    },
    {
      path: '/forgot_password',
      name: 'ForgotPassword',
      component: () => import('./views/login/forgot_password.vue')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('./views/register/index.vue')
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('./views/settings/index.vue')
    },
    {
      path: '/withdraw',
      name: 'Withdraw',
      component: () => import('./views/withdraw/index.vue')
    },
    {
      path: '/records',
      name: 'Records',
      component: () => import('./views/records/index.vue')
    },
    {
      path: '/revenue',
      name: 'Revenue',
      component: () => import('./views/revenue/index.vue')
    },
    {
      path: '/balance_detail',
      name: 'BalanceDetail',
      component: () => import('./views/revenue/balance_detail.vue')
    },
    {
      path: '/orders',
      name: 'Orders',
      component: () => import('./views/orders/index.vue')
    },
    {
      path: '/submission_records',
      name: 'SubmissionRecords',
      component: () => import('./views/records/submission.vue')
    },
    {
      path: '/messages',
      name: 'Messages',
      component: () => import('./views/messages/index.vue'),
			meta: { keepAlive: true }
    },
    {
      path: '/message_detail',
      name: 'MessageDetail',
      component: () => import('./views/messages/detail.vue')
    },
		{
		  path: '/auto_submission_records',
		  name: 'AutoSubmissionRecords',
		  component: () => import('./views/records/auto_submission.vue')
		},
  ]
})

router.beforeEach(async(to, from, next) => {
  next()
})

export default router